/**
 * Lightweight wrapper around window.gtag for GA4 events.
 * Silent no-op when gtag is unavailable (e.g. dev / blocked).
 *
 * Conversion events wired:
 *   - add_to_cart        (lib/cart.js -> addItem)
 *   - begin_checkout     (pages/Checkout.jsx -> submit)
 *   - purchase           (pages/Success.jsx -> on paid)
 *   - quote_request_submit (components/customizer/QuoteFromDesignModal.jsx -> on success)
 */
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch {
    /* no-op */
  }
}

/**
 * Build a GA4 ecommerce `items` array from cart line items.
 * https://developers.google.com/analytics/devguides/collection/ga4/reference/events#purchase
 */
export function toGa4Items(items = []) {
  return items.map((it, idx) => ({
    item_id: it.product_id || it.id || `item-${idx}`,
    item_name: it.product_name || it.name || "Item",
    item_category: it.product_category || it.type || "merch",
    item_variant: it.size || it.selected_color || undefined,
    price: Number(it.unit_price || it.price || 0),
    quantity: Number(it.quantity || 1),
  }));
}
